export function topicMatchesWildcardPath(topic, wildcardPath) {
    // use ^ and $ to mark start and end of string to avoid partial matches
    const regexString = `^${wildcardPath.replace(/\+/g, '\\w*')}$`;
    const regex = new RegExp(regexString);

    return topic.match(regex);
}
